import { createContext, useContext } from 'react';
import { liveBackend, type Backend } from '../net/backend';

/** The backend for this tab: live server, or offline fixtures under `/demo`. */
export const BackendContext = createContext<Backend>(liveBackend);

export function useBackend(): Backend {
  return useContext(BackendContext);
}
